import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Verbal Fluency — FTUE démo (3 essais courts, 15 s chacun).
 *
 * E1 : catégorie "animaux" — pédagogie de base "tape un mot par ligne".
 * E2 : lettre "P" — montre la contrainte phonemic + déduplication.
 * E3 : catégorie "fruits" — signal "prêt", skip vers session.
 */
import { useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — Animaux',
        hint: 'Tape un animal puis Entrée. Cherche 2 mots.',
        promptLabel: 'Animaux',
        mode: 'semantic',
        required: 2,
    },
    {
        idx: 2,
        title: 'Essai 2 — Lettre P',
        hint: 'Mêmes règles, mais chaque mot doit commencer par P. Cherche 2 mots.',
        promptLabel: 'Mots commençant par P',
        mode: 'phonemic',
        letter: 'p',
        required: 2,
    },
    {
        idx: 3,
        title: 'Essai 3 — Fruits',
        hint: 'Round normal : 30 à 90 secondes selon ton niveau.',
        promptLabel: 'Fruits',
        mode: 'semantic',
        required: 1,
    },
];
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const [draft, setDraft] = useState('');
    const [words, setWords] = useState([]);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    const enough = words.length >= step.required;
    const handleSubmit = () => {
        const v = draft.trim().toLowerCase();
        if (v.length < 2)
            return;
        if (step.mode === 'phonemic' && step.letter && v[0] !== step.letter)
            return;
        if (words.includes(v))
            return;
        setWords((w) => [...w, v]);
        setDraft('');
    };
    const handleNext = () => {
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
        setDraft('');
        setWords([]);
    };
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsxs("div", { className: "flex flex-col items-center gap-s2", children: [_jsx("p", { className: "font-mono text-[10px] uppercase tracking-[0.20em] text-cyan-text-faint", children: "Consigne" }), _jsx("h3", { className: "font-display text-[28px] font-medium tracking-cy-display text-cyan-text", children: step.promptLabel })] }), _jsxs("div", { className: "flex w-full max-w-[320px] flex-col gap-s3", children: [_jsx("input", { type: "text", value: draft, onChange: (e) => setDraft(e.target.value), onKeyDown: (e) => {
                            if (e.key === 'Enter' || e.key === 'Tab') {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }, placeholder: "un mot...", className: "w-full border border-cyan-border bg-cyan-surface px-s4 py-s3 text-[15px] text-cyan-text focus:border-cyan-core focus:outline-none" }), _jsx("button", { type: "button", onClick: handleSubmit, disabled: draft.trim().length < 2, className: "inline-flex h-10 items-center justify-center bg-cyan-core px-s5 font-display text-[13px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network disabled:opacity-40", children: "Ajouter" })] }), words.length > 0 && (_jsx("div", { className: "flex flex-wrap justify-center gap-s2", children: words.map((w, i) => (_jsx("span", { className: "border border-cyan-network/30 bg-cyan-network/15 px-s3 py-s1 text-[11px] text-cyan-text", children: w }, `${w}-${i}`))) })), _jsxs("div", { className: "mt-auto flex flex-col items-stretch gap-s3 self-stretch", children: [enough && (_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' })), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map